module.exports = __webpack_public_path__ + "img/smoke.f6a8a91a.gif";